export interface GameInterface {
	isVisible: boolean,
}

export const gameInterfaceDefault: GameInterface = {
	isVisible: true,
};